<template>
    <v-container fluid>
      <v-toolbar
        dark
        color="primary lighten"
        :extended="$vuetify.breakpoint.smAndDown"
        >
        <v-select
          class="mt-7"
          v-model="selectedCompany"
          :items="companyOptions"
          item-value="name"
          item-text="desc"
          label="Select Company"          
          return-object
          @change="fetchData"
          color="primary darken-3"
          ></v-select>
        <v-divider
          class="mx-4"
          inset
          vertical
          v-if="$vuetify.breakpoint.mdAndUp"
          ></v-divider>
          <v-spacer></v-spacer>
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <template v-slot:extension v-if="$vuetify.breakpoint.smAndDown">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details           
            color="primary darken-3"
            :disabled="!selectedCompany"
          ></v-text-field>
      </template>
        <v-text-field
        v-if="$vuetify.breakpoint.mdAndUp"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details            
            color="primary darken-3"
            :disabled="!selectedCompany"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn icon @click="fetchData" :disabled="!selectedCompany">
            <v-icon > mdi-refresh</v-icon>
        </v-btn> 
        <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>   
      </v-toolbar> 
      <v-alert
        v-if="!selectedCompany"
        outlined
        type="info"
        prominent
        border="left"
        class="mt-2"
      >
      Please Select Company
      </v-alert>   
    <!-- Table view for non-mobile screens -->
      <v-card  v-if="!$vuetify.breakpoint.xsOnly">
        <v-data-table
          :headers="headers"
          :items="summaryData"
          :search="search"
          :loading="loading"
          :items-per-page="10"
          class="elevation-1"
        >
        <template v-slot:item.Average_Score="{ item }">
            {{ formatNumber(item.Average_Score) }}
        </template>
        <template v-slot:item.Sum_Average_Score="{ item }">
            {{ formatNumber(item.Sum_Average_Score) }}
        </template>
        <template v-slot:item.Sum_Avg_Appe_Score="{ item }">
            {{ formatNumber(item.Sum_Avg_Appe_Score) }}
        </template>
        <template v-slot:item.Sum_Avg_Self_Score="{ item }">
            {{ formatNumber(item.Sum_Avg_Self_Score) }}
        </template>
        <template v-slot:item.Sum_SelfVsAppeAvg="{ item }">
            {{ formatNumber(item.Sum_SelfVsAppeAvg) }}
        </template>
        </v-data-table>
      </v-card>


    <!-- List view for mobile screens -->
    <v-card v-else>    
      
      <v-list two-line>
        <template v-for="(item, index) in filteredData">
          <!-- eslint-disable vue/valid-v-for -->
          <!-- eslint-disable-next-line vue/valid-v-for -->
          <v-list-item :key="item.APS_AppraiseeCode" >
            <v-list-item-content>
              <v-list-item-title>{{ formatName(item.EMPMST_NAME) }}</v-list-item-title>
              <v-list-item-subtitle>
                Appraisee Code: {{ item.APS_AppraiseeCode }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Appraisal Score: {{ formatNumber(item.Average_Score) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Common Ques(5). Score: {{ formatNumber(item.Sum_Avg_Self_Score) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Avg. Appe Common(5) Score: {{ formatNumber(item.Sum_Avg_Appe_Score) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Sum Self vs Appe Avg: {{ formatNumber(item.Sum_SelfVsAppeAvg) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index < filteredData.length - 1" :key="index"></v-divider>
        </template>
      </v-list>
    </v-card>
    </v-container>
  </template>
  
  <script>
 import dynamic_axios from "../services/dynamic_axios";
  
  export default {
    name: 'AppraisalSummaryTable',
    data() {
      return {
        search: '',
        loading: false,
        summaryData: [],
        selectedCompany:null,
        companyOptions: [
            { name: 'skymat', desc: 'SKYMAT' },
            { name: 'triton', desc: 'TRITON' }
        ],
        headers: [
          { text: 'Name', value: 'EMPMST_NAME' },
          { text: 'Type', value: 'APQ_Type' },
          { text: 'Appraisers', value: 'Distinct_Appraisers' },
          { text: 'Appraisee Code', value: 'APS_AppraiseeCode' },
          { text: 'Appraisal Score', value: 'Average_Score' },
        //   { text: 'Sum Average Score', value: 'Sum_Average_Score' },
          // {
          //   title: ' Score Compared',
          //   align: 'center',
          //   sortable: false,
          //   value: 'dimensions',
          //   children: [
          //     { title: 'Common Ques(5). ', value: 'Sum_Avg_Self_Score' },
          //     { title: 'Avg. Appe Common(5) ', value: 'Sum_Avg_Appe_Score' },
          //     { title: 'Self vs Appe ', value: 'Sum_SelfVsAppeAvg' },
          //   ],
          // },
          { text: 'Common Ques(5). Score', value: 'Sum_Avg_Self_Score' },
          { text: 'Avg. Appe Common(5) Score', value: 'Sum_Avg_Appe_Score' },          
          { text: 'Sum Self vs Appe Avg', value: 'Sum_SelfVsAppeAvg' },
        ],
      };
    },
    // mounted() {
    //   this.fetchData();
    // },
    computed:{
        user() {     
            return this.$store.getters.factsuser;      
        },
        filteredData() {
            return this.summaryData.filter(item =>
                Object.values(item).some(val =>
                String(val).toLowerCase().includes(this.search.toLowerCase())
                )
            );
            },
    },
    methods: {
      async fetchData() {
        this.loading = true;
        try {
            const user_id = this.user.USER_LOGINID;
            const company = this.selectedCompany?.name;
            const params = new URLSearchParams({
                user_id
                }).toString();
          const response = await dynamic_axios.get(`/appraisal/apprmgntsummary?${params}`, {
            apiName:company  // Specify which API configuration to use
          });
          this.summaryData = response.data;
        } catch (error) {
          console.error('Error fetching data:', error);
          // You might want to add error handling here, such as displaying a snackbar
        } finally {
          this.loading = false;
        }
      },
      formatName(name) {
        return name.split(" ", 2).join(" ");
        },
      formatNumber(value) {
        if (value === null || value === undefined) {
            return 'N/A';
        }
        return Number(value).toFixed(2);
      }
    },
  };
  </script>